export default {
  top: '/users/mypage/list',
  invitation: '/users/mypage/invitation',
};
